import GoldLocked from 'assets/images/gold-locked.svg'
import Column from 'components/Column'
import Link from 'components/Link'
import Text from 'components/Text'
import { ErrorType } from 'data/App/types'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { getSupportLink } from 'services/urlService'
import styled from 'styled-components'

import Container from '../Modal/Container'

const ColumnTitle = styled(Column)`
  align-items: center;
`
const Col = styled(Column)`
  text-align: center;
`
const GoldLockedImg = styled.img`
  margin-bottom: 1rem;
`
const StatusCode = styled(Text)`
  margin-bottom: 1rem;
`

type PropsType = ErrorType & WrappedComponentProps

const TierTwoError = ({ cause, intl }: PropsType) => {
  return (
    <Container
      sub={intl.formatMessage(messages.gold_unavailable_info_subtitle)}
      title={
        <ColumnTitle>
          <GoldLockedImg src={GoldLocked} />
          {intl.formatMessage(messages.gold_unavailable_title)}
        </ColumnTitle>
      }
      theme='dark'
    >
      <Col>
        <StatusCode color='dark800'>Server Error: {cause}</StatusCode>
        <Text color='dark200'>
          {intl.formatMessage(messages.learn_more_about_verification)}{' '}
          <Link
            color='blue600'
            href={getSupportLink(intl.locale)}
            rel='noopener noreferrer'
            target='_blank'
          >
            {intl.formatMessage(messages.support_center)}
          </Link>
        </Text>
      </Col>
    </Container>
  )
}

export default injectIntl(TierTwoError)
